import {
  AUTHORIZED_USER_DETAILS,
  CONTRACT_DETAILS_ERROR,
  CONTRACT_DETAILS_LOADER,
  CONTRACT_NUMBERS_ERROR,
  CONTRACT_NUMBERS_LOADER,
  FETCH_LEIN_DEREGISTRATION_DATA,
  GET_ALL_CONTRACTS,
  GET_CONTRACT_DETAILS,
  GET_CONTRACT_NUMBERS,
  GET_NOTIFICATIONS,
  GET_PAYMENT_SCHEDULE,
  GET_USER_DETAILS_INFO,
  INCORRECT_DATA_NAME,
  MY_ACCOUNT_DETAILS,
  NO_SCHEDULE_DATA,
  PAYMENT_SCHEDULE_ERROR,
  PAYMENT_SCHEDULE_LOADER,
  POP_STATE,
  PUSH_VIEW,
  RESET_STATE,
  RESET_VIEW,
  SERVICE_REQUEST_DETAILS,
  SERVICE_REQUEST_ERROR,
  SERVICE_REQUEST_INFO,
  DOCUMENT_REDIRECTION_INFO,
  SERVICE_REQUEST_LOADER,
  SET_CONTRACT_QUERY,
  SET_MONTH_QUERY,
  SET_ORG,
  SET_ROLE_ACCESS,
  SET_ROLE,
  UPDATE_ASSET_STATUS,
  ASK_USER_TO_ENABLE_PUSH,
} from './actionsTypes';
import {loadUserDevicePushToken} from './deviceTokenActions';

export const getUserDetailsInfoAction = (data) => {
  return {
    type: GET_USER_DETAILS_INFO,
    data,
  };
};
export const getServiceRequestInfoAction = (data) => {
  return {
    type: SERVICE_REQUEST_INFO,
    data,
  };
};
export const getDocumentRedirectionInfoAction = (data) => {
  return {
    type: DOCUMENT_REDIRECTION_INFO,
    data,
  };
};
export const getServiceRequestDetailsAction = (data) => {
  return {
    type: SERVICE_REQUEST_DETAILS,
    data,
  };
};
export const getAuthorizedUserDetailsAction = (data) => {
  return {
    type: AUTHORIZED_USER_DETAILS,
    data,
  };
};

export const incorrectDataNameAction = (data) => {
  return {
    type: INCORRECT_DATA_NAME,
    data,
  };
};
export const getContractNumbersAction = (data) => {
  return {
    type: GET_CONTRACT_NUMBERS,
    data,
  };
};
export const getPaymentScheduleAction = (data) => {
  return {
    type: GET_PAYMENT_SCHEDULE,
    data,
  };
};
export const paymentScheduleLoaderAction = (data) => {
  return {
    type: PAYMENT_SCHEDULE_LOADER,
    data,
  };
};
export const getAllContractsAction = (data) => {
  return {
    type: GET_ALL_CONTRACTS,
    data,
  };
};
export const paymentScheduleErrorAction = (error) => {
  return {
    type: PAYMENT_SCHEDULE_ERROR,
    error,
  };
};

export const contractNumberLoaderAction = (data) => {
  return {
    type: CONTRACT_NUMBERS_LOADER,
    data,
  };
};

export const contractNumberErrorAction = (error) => {
  return {
    type: CONTRACT_NUMBERS_ERROR,
    error,
  };
};

export const serviceRequestLoaderAction = (data) => {
  return {
    type: SERVICE_REQUEST_LOADER,
    data,
  };
};

export const serviceRequestErrorAction = (error) => {
  return {
    type: SERVICE_REQUEST_ERROR,
    error,
  };
};

export const setContractQueryAction = (contractNo) => {
  return {
    type: SET_CONTRACT_QUERY,
    contractNo,
  };
};
export const setMonthQueryAction = (month) => {
  return {
    type: SET_MONTH_QUERY,
    month,
  };
};
export const noScheduleDataAction = (data) => {
  return {
    type: NO_SCHEDULE_DATA,
    data,
  };
};
export const pushViewAction = (data) => {
  return {
    type: PUSH_VIEW,
    newView: data,
  };
};

export const popViewAction = () => {
  return {
    type: POP_STATE,
  };
};

export const resetViewAction = () => {
  return {
    type: RESET_VIEW,
  };
};

export const setOrganization = (data) => {
  return {
    type: SET_ORG,
    data,
  };
};
export const getContractDetailsAction = (data) => {
  return {
    type: GET_CONTRACT_DETAILS,
    data,
  };
};
export const contractDetailsLoaderAction = (data) => {
  return {
    type: CONTRACT_DETAILS_LOADER,
    data,
  };
};
export const contractDetailsErrorAction = (error) => {
  return {
    type: CONTRACT_DETAILS_ERROR,
    error,
  };
};

export const resetStateAction = () => {
  return {
    type: RESET_STATE,
  };
};

export const getMyAccountDetailsAction = (data) => {
  return {
    type: MY_ACCOUNT_DETAILS,
    data,
  };
};

export const fetchLienDeregistrationDataAction = (data) => {
  return {
    type: FETCH_LEIN_DEREGISTRATION_DATA,
    data,
  };
};

export const inAppNotificationAction = (data) => {
  return {
    type: GET_NOTIFICATIONS,
    data,
  };
};
export const updateAssetStatus = (data) => {
  return {
    type: UPDATE_ASSET_STATUS,
    data,
  };
};
export const setRole = (data) => {
  return {
    type: SET_ROLE,
    data,
  };
};

export const setRoleAccess = (data) => {
  return {
    type: SET_ROLE_ACCESS,
    data,
  };
};

export const showEnablePushNotificationModel = (data) => {
  return {
    type: ASK_USER_TO_ENABLE_PUSH,
    data,
  };
};

export {loadUserDevicePushToken};
